var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "publishRuleConfigWrap bj" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("el-button", {
            staticClass: "bjsearch",
            attrs: { type: "primary", icon: "el-icon-refresh" },
            on: { click: _vm.Refresh },
          }),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.onHandleTag()
                },
              },
            },
            [_vm._v("新增属性")]
          ),
          _vm.showName
            ? _c("span", { staticClass: "showNameWrap" }, [
                _vm._v("当前所属品类【" + _vm._s(_vm.showName) + "】"),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.listData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "100px",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "field_key",
                  align: "center",
                  label: "属性名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_must_txt",
                  align: "center",
                  label: "是否必填",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_show",
                  align: "center",
                  label: "是否显示隐藏",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#409EFF",
                            "inactive-color": "#C0CCDA",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeShow(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.value,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "value", $$v)
                            },
                            expression: "scope.row.value",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "is_searchable_txt",
                  align: "center",
                  label: "是否在分类页显示",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "product_edit_type_txt",
                  align: "center",
                  label: "是否可编辑",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "purchase_parameter",
                  align: "center",
                  label: "排序",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.$index != 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.postAjaxCategoriesCustomFieldSort(
                                      scope.row,
                                      scope.$index,
                                      1
                                    )
                                  },
                                },
                              },
                              [_vm._v("上移")]
                            )
                          : _vm._e(),
                        scope.$index != _vm.listData.length - 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.postAjaxCategoriesCustomFieldSort(
                                      scope.row,
                                      scope.$index,
                                      2
                                    )
                                  },
                                },
                              },
                              [_vm._v("下移")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandleviewProperties(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看属性值")]
                        ),
                        scope.row.system_type != 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleTag(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑属性")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("add-attribute", {
        ref: "addAttributeRef",
        attrs: { cidType: _vm.cidType },
        on: { "on-change": _vm.Refresh },
      }),
      _c("view-properties", {
        ref: "viewPropertiesRef",
        on: { "on-change": _vm.Refresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }